import type { Config } from "./config.contract";
import { EnvironmentType } from "./config.types";
import {
  BlueEnvironment,
  HmlEnvironment,
  LocalEnvironment,
  ProductionEnvironment,
} from "./environments";

export function ConfigFactory(environmentType: EnvironmentType): Config {
  switch (environmentType) {
    case EnvironmentType.PRODUCTION:
      return new ProductionEnvironment();
    case EnvironmentType.BLUE:
      return new BlueEnvironment();
    case EnvironmentType.HML:
      return new HmlEnvironment();
    case EnvironmentType.LOCAL:
      return new LocalEnvironment();
    default:
      throw new Error("Invalid environment type");
  }
}
